import { ServerTransactionStatusEnum } from '@expane/data'
import { isThisCompletedPaymentTransaction } from '../transaction/checks'
import {
  isThisCompletedRefundTransaction,
  isThisPendingRefundTransaction,
} from '../transaction/refund/checks'

export const filterBoughtCards = <
  T extends {
    transactionCards: Array<{
      transaction: {
        status: ServerTransactionStatusEnum
        type: number
        typeVariation: number | null
      }
    }>
  },
>(
  cards: T[],
): T[] =>
  cards.filter(card =>
    card.transactionCards.some(({ transaction }) => isThisCompletedPaymentTransaction(transaction)),
  )

// Ми враховуємо транзакції повернення, і якщо був запит на повернення (через платіжну систему тощо)
export const filterWithoutRefundedCards = <
  T extends {
    transactionCards: Array<{
      transaction: {
        status: ServerTransactionStatusEnum
        type: number
        typeVariation: number | null
      }
    }>
  },
>(
  cards: T[],
): T[] =>
  cards.filter(
    card =>
      !card.transactionCards.some(
        ({ transaction }) =>
          isThisCompletedRefundTransaction(transaction) ||
          isThisPendingRefundTransaction(transaction),
      ),
  )
